// Collection names as constants to avoid typos
export const COLLECTIONS = {
  SURVEYS: 'surveys',
  POIS: 'pois',
  ROUTES: 'routes',
  TRACK_POINTS: 'track_points',
  HIGH_POLE_POIS: 'high_pole_pois',
  QUICK_SURVEY_POIS: 'quick_survey_pois',
  BOOK_SURVEYS: 'book_surveys',
  HAUTEURS_LIBRES: 'hauteurs_libres', // Single collection for all structure data
  PENDING_UPLOADS: 'pendingUploads',
  SHARED_MAPS: 'shared_maps',
  TEAM_MESSAGES: 'team_messages',
  TEAM_FILES: 'team_files'
};